import type { FC } from 'react';

import { SITE_CONTAINER } from '@/features/home/constants/homeStyles.constants';
import type { MoneyPanel } from '@/types/home.types';

interface MoneySectionProps {
  panels: MoneyPanel[];
}

const MoneySection: FC<MoneySectionProps> = ({ panels }) => (
  <section className="bg-site-bg">
    <div className={`${SITE_CONTAINER} pb-16 md:pb-[88px]`}>
      <div className="grid grid-cols-[repeat(auto-fit,minmax(min(100%,340px),1fr))] gap-0.5 border-2 border-site-ink bg-site-ink">
        {panels.map((panel) => (
          <div key={panel.eyebrow} className="flex flex-col gap-3 bg-site-bg p-8">
            <span className="font-site text-[13px] tracking-[0.08em] text-site-accent-deep uppercase">
              {panel.eyebrow}
            </span>
            <h2 className="font-site text-[26px] font-extrabold tracking-[-0.01em]">
              {panel.title}
            </h2>
            {panel.paragraphs.map((paragraph) => (
              <p key={paragraph} className="font-site text-base leading-[1.5] text-site-ink/80">
                {paragraph}
              </p>
            ))}
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default MoneySection;
